export default "__VITE_ASSET__He1zFzqR__"